import React, { useMemo } from 'react';
import type { CommandPaletteBodyProps } from '../../../../common/types/commands/index.tsx';
import { components } from '../../../../common/ui/components/index.tsx';
import { getActiveCommandList } from '../../../../common/utils/get-active-command-list/index.tsx';
import { useCommandPaletteExpandedCommand } from '../../../../controllers/command-palette/index.tsx';

export const Body = ({
	fallback,
	results,
	total,
	renderAfterCommands,
}: CommandPaletteBodyProps): React.JSX.Element => {
	const [{ expandedCommand }, { setChildCommands, setLoadingList, setFallbackOverride }] =
		useCommandPaletteExpandedCommand();
	const ExpandedBody = useMemo(
		() =>
			getActiveCommandList(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.components
				?.Body || components.Body,
		[expandedCommand],
	);

	return (
		<ExpandedBody
			setChildResult={setChildCommands}
			setLoading={setLoadingList}
			fallback={fallback}
			results={results}
			total={total}
			renderAfterCommands={renderAfterCommands}
			setFallbackOverride={setFallbackOverride}
		/>
	);
};
